import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import { getHistoryItems, useHistory } from "@/hooks/useLocalLibrary";
import { mediaList } from "@/mocks/media";

const stats = [
  { value: "612", label: "在库影视" },
  { value: "48", label: "每日更新" },
  { value: "1080P", label: "资料画质" },
  { value: "3", label: "核心分类" },
];

export default function ContinueWatching() {
  const { historyIds, clear } = useHistory();
  const history = getHistoryItems(historyIds).slice(0, 6);
  const picks = mediaList.filter((item) => item.rating >= 8.6).slice(0, 3);

  if (history.length === 0) {
    return (
      <section className="w-full border-t border-background-200 px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.22em] text-accent-600">
              <span className="h-px w-6 bg-accent-500" />
              Browse History
            </p>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">浏览记录</h2>
            <p className="mt-3 text-[13px] leading-relaxed text-foreground-600">
              还没有浏览记录。打开任意一部影视详情页后，这里会自动保存你最近看过的 12 部作品，仅保存在当前浏览器本地。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {picks.map((item) => (
                <Link
                  key={item.id}
                  to={`/detail/${item.id}`}
                  className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-[12px] text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600"
                >
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
          <div className="grid w-full grid-cols-2 gap-3 sm:grid-cols-4 lg:w-auto">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-200 bg-background-100/70 px-4 py-4">
                <p className="font-heading text-xl font-bold text-primary-700">{stat.value}</p>
                <p className="mt-1 font-label text-[11px] text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full border-t border-background-200 px-4 py-12 md:px-6 md:py-14">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.22em] text-accent-600">
            <span className="h-px w-6 bg-accent-500" />
            Browse History
          </p>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">继续浏览</h2>
          <p className="mt-2 text-[13px] text-foreground-600">最近查看过的影视作品，仅保存在当前浏览器</p>
        </div>
        <button
          type="button"
          onClick={clear}
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-[12px] text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-600"
        >
          <i className="ri-delete-bin-line flex h-4 w-4 items-center justify-center" />
          清空记录
        </button>
      </div>
      <div className="grid grid-cols-3 gap-3 md:grid-cols-6 md:gap-4">
        {history.map((item) => (
          <MediaCard key={item.id} item={item} compact />
        ))}
      </div>
    </section>
  );
}